import { PROJECT_STATUS } from "@/enums";
import { IProjectStatus } from "@/interfaces";

export const getProjectStatusTranslationId = (statusId: string): string => {
  const intakeStatus = getTranslationId(PROJECT_STATUS.intake, statusId);
  const projectStatus = getTranslationId(PROJECT_STATUS.project, statusId);

  return (
    intakeStatus?.translationId ||
    projectStatus?.translationId ||
    "projectStatus.unknown"
  );
};

const getTranslationId = (
  statuses: { [key: string]: IProjectStatus },
  statusId: string
): IProjectStatus | undefined =>
  Object.values(statuses).find((status) => status.id === statusId);
